import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './apiSlice';
import { pageLookupApi } from './pageLookup/pageLookupApiSlice';
import authReducer from './auth/authSlice';
import configReducer from './config/configSlice';
import storageMiddleware from './middlewares/storageMiddleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    [pageLookupApi.reducerPath]: pageLookupApi.reducer,
    config: configReducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(storageMiddleware, apiSlice.middleware, pageLookupApi.middleware),
  devTools: true
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
